import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";
import { NavBarIcon, Button } from "@similarweb/ui-components";

import { PagePreviewWrapper } from "pro-features/components/PagePreview/styledComponents";
import { AssetsService } from "app/services/AssetsService";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const imageWrapperPadding = "60px";
const Text = styled(FlexColumn)<{ isImageBeforeText: boolean }>`
    height: 100%;
    ${({ isImageBeforeText }) =>
        isImageBeforeText ? `padding-left : ${imageWrapperPadding};` : `padding-right : ${imageWrapperPadding};`}

    @media only screen and (max-width: 1400px) {
        ${({ isImageBeforeText }) => (isImageBeforeText ? `padding-left : 40px;` : `padding-right : 40px;`)}
    }
`;
const SubText = styled(FlexColumn)``;
const TextName = styled(FlexColumn)`
    justify-content: space-between;
    height: 100%;
`;
const Title = styled.span`
    ${setFontVariant("h4", colorsPalettes.carbon[500])};
    padding-bottom: 24px;
    @media only screen and (max-width: 1400px) {
        ${setFontVariant("h6", colorsPalettes.carbon[500])};
        padding-bottom: 16px;
    }
`;
const Description = styled.span`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[400])};
    padding-left: 10px;
    @media only screen and (max-width: 1400px) {
        ${setFontVariant("subtitle2", colorsPalettes.carbon[400])};
    }
`;

const DescriptionWrapper = styled(FlexRow)`
    padding-bottom: 8px;
`;

const ImgWrapper = styled.span`
    display: flex;
    height: 100%;
    width: 350px;
    border-radius: 6px;
    box-shadow: 0 18px 34px ${rgba(colorsPalettes.carbon[300], 0.2)};
    @media only screen and (max-width: 1400px) {
        ${setFontVariant("subtitle2", colorsPalettes.carbon[400])};
        width: 265px;
    }
`;

interface IPagePreviewProps {
    isImageBeforeText: boolean;
    image: string;
    title: string;
    descriptions: string[];
    textButton?: string;
    onClickButton?: () => void;
}

export const PagePreview: FC<IPagePreviewProps> = ({
    isImageBeforeText,
    image,
    title,
    descriptions,
    textButton,
    onClickButton,
}) => {
    const DisplayImage = () => {
        return (
            <ImgWrapper>
                <img
                    style={{ display: "inline-block", height: "100%", maxWidth: "none" }}
                    src={AssetsService.assetUrl(image)}
                    alt={title}
                />
            </ImgWrapper>
        );
    };
    const PreviewText = () => {
        return (
            <Text isImageBeforeText={isImageBeforeText}>
                <Title>{title}</Title>
                <TextName>
                    <SubText>
                        {descriptions.map((descriptionText, index) => {
                            return (
                                <DescriptionWrapper key={index.toString()}>
                                    <NavBarIcon
                                        iconName="checked"
                                        iconSize="xs"
                                        iconColor={colorsPalettes.blue[300]}
                                    />
                                    <Description>{descriptionText}</Description>
                                </DescriptionWrapper>
                            );
                        })}
                    </SubText>
                    {textButton ? (
                        <Button
                            width={"fit-content"}
                            onClick={onClickButton}
                        >
                            {textButton}
                        </Button>
                    ) : null}
                </TextName>
            </Text>
        );
    };

    return (
        <PagePreviewWrapper>
            {isImageBeforeText ? (
                <>
                    {DisplayImage()}
                    {PreviewText()}
                </>
            ) : (
                <>
                    {PreviewText()}
                    {DisplayImage()}
                </>
            )}
        </PagePreviewWrapper>
    );
};
